import React from 'react';
import { RoleBadge, CompanyTag, SurveyTag, YouTag } from './Badges';
import TempPasswordInfo from './TempPasswordInfo';
import PasswordChip from './PasswordChip';

// A single user row. Optionally shows a company tag (dev view), the survey a
// one-time account was created for, a temp password (just after creation), a
// one-time-password info button + reset action (for whoever supervises this
// user), and a remove button.
const UserRow = ({
  member,
  showCompany,
  password,
  onDelete,
  canDelete,
  onResetPassword,
  canResetPassword,
  showTempPassword,
  indent,
  currentUserId,
}) => (
  <li className={`hover:bg-gray-700/30 transition-colors duration-200 ${indent ? 'pl-6' : ''}`}>
    <div className="px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center min-w-0 flex-1">
          <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-r from-purple-400 to-violet-500 rounded-lg mr-4 flex-shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-white" viewBox="0 0 8 8" aria-hidden="true">
              <path fill="currentColor" d="M4 0C2.9 0 2 1.12 2 2.5S2.9 5 4 5s2-1.12 2-2.5S5.1 0 4 0M1.91 5C.85 5.05 0 5.92 0 7v1h8V7c0-1.08-.84-1.95-1.91-2c-.54.61-1.28 1-2.09 1s-1.55-.39-2.09-1" />
            </svg>
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <h4 className="text-base font-semibold text-white truncate">{member.email}</h4>
              {showTempPassword && <TempPasswordInfo member={member} />}
              {member.id === currentUserId && <YouTag />}
            </div>
            <div className="flex items-center gap-2 mt-1 flex-wrap">
              <RoleBadge role={member.role} />
              <SurveyTag name={member.assigned_form_name} />
              {showCompany && <CompanyTag name={member.company_name} />}
            </div>
            {password && (
              <div className="mt-2 flex items-center gap-2 flex-wrap text-sm text-gray-400">
                <span className="font-medium">Temporary password:</span>
                <PasswordChip password={password} />
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2 ml-4 flex-shrink-0">
          {onResetPassword && canResetPassword?.(member) && (
            <button
              onClick={() => onResetPassword(member)}
              className="bg-purple-500/10 hover:bg-purple-500/20 text-purple-300 hover:text-purple-200 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 border border-purple-500/20 hover:border-purple-500/40"
            >
              Reset Password
            </button>
          )}
          {onDelete && (canDelete ? canDelete(member) : member.id !== currentUserId) && (
            <button
              onClick={() => onDelete(member)}
              className="bg-red-500/10 hover:bg-red-500/20 text-red-400 hover:text-red-300 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 border border-red-500/20 hover:border-red-500/40"
            >
              Remove
            </button>
          )}
        </div>
      </div>
    </div>
  </li>
);

export default UserRow;
